import React from 'react';
import AppSidebar from '../../../../../../../base/components/layout/app-sidebar';

const HeaderNavigations = () => <AppSidebar />;

export default HeaderNavigations;
